const algoliasearch = require('algoliasearch')

module.exports = algoliasearch
